function monthIndex(date) {
    return date.getFullYear() * 12 + date.getMonth();
}

const pretCalculator = {
    totalMonths(pret) {
        const debut = new Date(pret.date_debut);
        const fin = new Date(pret.date_fin);

        return Math.max(monthIndex(fin) - monthIndex(debut) + 1, 0);
    },

    elapsedMonths(pret, now = new Date()) {
        const debut = new Date(pret.date_debut);
        const total = this.totalMonths(pret);
        const elapsed = monthIndex(now) - monthIndex(debut) + 1;

        return Math.min(Math.max(elapsed, 0), total);
    },

    elapsedAmount(pret, now = new Date()) {
        const total = this.totalMonths(pret);

        if (total === 0) {
            return 0;
        }

        return (pret.amount / total) * this.elapsedMonths(pret, now);
    },

    progress(pret, now = new Date()) {
        if (!pret.amount) {
            return 0;
        }

        return Math.min(100 * this.elapsedAmount(pret, now) / pret.amount, 100);
    },

    totalAmount(prets) {
        return prets.reduce((sum, pret) => sum + Number(pret.amount || 0), 0);
    },

    totalElapsedAmount(prets, now = new Date()) {
        return prets.reduce((sum, pret) => sum + this.elapsedAmount(pret, now), 0);
    },

    globalProgress(prets, now = new Date()) {
        const totalAmount = this.totalAmount(prets);

        if (totalAmount === 0) {
            return 0;
        }

        return Math.min(100 * this.totalElapsedAmount(prets, now) / totalAmount, 100);
    }
};

export default pretCalculator;
